export enum Context {
  hp = 'HOME_IMPLICIT',
  destinationResults = 'OPEN_SEARCH',
  listResults = 'SINGLE_SEARCH',
  hotelDetail = 'DETAIL',
}

export enum Platform {
  tsx = 'TSX',
}

export enum FunnelLayout {
  tsx = 'TSX',
  tsxCc = 'TSX_CC',
  tsxDpEvo = 'TSX_DP_EVO',
}

export type HotelDetailShownResponseCodes =
  | 'OK'
  | 'ERROR_FETCHING_ROOMS'
  | 'ERROR_ROOMS_RESPONSE'
  | 'ERROR_SEARCH_RESPONSE'
  | 'ERROR_CMS_CONFIGURATION'
  | 'ERROR_HOTEL_STATIC_DATA'
  | 'ERROR_DICTIONARY'
  | 'ERROR_PRICING_ASYNC'
  | 'ERROR_PRICING_RESPONSE_INVALID'
  | 'ERROR_PROCESSING_ROOMS_RESPONSE'
  | 'PAGE_UNLOAD'
  | 'ROOM_NOT_AVAILABLE'
  | 'TRANSPORT_NOT_AVAILABLE'
  | 'PAST_DATES'
  | 'NONE';

export type Page = 'RESULT_PAGE' | 'DETAIL_PAGE' | 'SUMMARY';

/** Page the user was on when triggering a change-flight tracking event. */
export type ChangeFlightPage = 'Hotel Detail' | 'Flight Detail';

export type PartialStay = {
  flag: boolean;
  dateFrom: string | null;
  dateTo: string | null;
};
